import ErrorTemplate from '../components/templates/ErrorTemplate';

export default function ErrorPage() {
  return (
    <ErrorTemplate />
  );
}
